"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchV2WithParamsToQuery = void 0;
const attributes_1 = require("../../helpers/attributes");
const ProductWith_1 = require("../../types/ProductWith");
const searchV2WithParamsToQuery = (includes) => {
    const params = [];
    let depth = 0;
    if (includes === null || includes === void 0 ? void 0 : includes.categories) {
        if (includes.categories.parents === 'all') {
            params.push('category.parents');
        }
        if (includes.categories.children) {
            depth = includes.categories.children + 1;
            params.push('category.children');
        }
    }
    if (includes === null || includes === void 0 ? void 0 : includes.product) {
        params.push((0, attributes_1.prefixList)('product.')((0, ProductWith_1.productWithQueryParameterValues)(includes.product)));
    }
    if (params.length === 0) {
        return {};
    }
    return {
        with: params.join(','),
        'category.depth': depth,
    };
};
exports.searchV2WithParamsToQuery = searchV2WithParamsToQuery;
